import { Link, Navigate, Outlet, useLocation } from 'react-router-dom'
import { Users, CreditCard, Shield, MessageSquare, Building2, AlertTriangle, Tag, UserCheck } from 'lucide-react'
import { useUserRole } from '../../hooks/useUserRole'

const adminTabs = [
  { name: 'Organizacje', href: '/admin/organizations', icon: Building2, description: 'Zarządzanie organizacjami' },
  { name: 'Użytkownicy', href: '/admin/users', icon: Users, description: 'Zarządzanie kontami użytkowników' },
  { name: 'Subskrypcje', href: '/admin/subscriptions', icon: CreditCard, description: 'Plany i rozliczenia' },
  { name: 'Logi Audytu', href: '/admin/audit', icon: Shield, description: 'Historia działań w systemie' },
  { name: 'Kody rabatowe', href: '/admin/discount-codes', icon: Tag, description: 'Zarządzanie kodami rabatowymi' },
  { name: 'Przedstawiciele', href: '/admin/representatives', icon: UserCheck, description: 'Przedstawiciele i prowizje' },
  { name: 'Błędy', href: '/admin/errors', icon: AlertTriangle, description: 'Logi błędów aplikacji' },
  { name: 'Zgłoszenia', href: '/admin/feedback', icon: MessageSquare, description: 'Zgłoszenia od użytkowników' },
]

export default function AdminDashboard() {
  const location = useLocation()
  const { isAdmin, isLoading } = useUserRole()
  const isAdminRoot = location.pathname === '/admin'

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />
  }

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Panel Administratora</h1>
        <p className="mt-1 text-sm text-gray-500">
          Zarządzanie systemem LexTool
        </p>
      </div>

      {/* Admin navigation tabs */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex space-x-8">
          {adminTabs.map((tab) => {
            const isActive = location.pathname === tab.href
            return (
              <Link
                key={tab.name}
                to={tab.href}
                className={`flex items-center py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                  isActive
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <tab.icon className="w-5 h-5 mr-2" />
                {tab.name}
              </Link>
            )
          })}
        </nav>
      </div>

      {/* Show cards on admin root, otherwise show nested content */}
      {isAdminRoot ? (
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {adminTabs.map((tab) => (
            <Link
              key={tab.name}
              to={tab.href}
              className="relative bg-white p-6 rounded-lg shadow hover:shadow-md transition-shadow border border-gray-200"
            >
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <tab.icon className="h-8 w-8 text-blue-600" />
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-medium text-gray-900">{tab.name}</h3>
                  <p className="mt-1 text-sm text-gray-500">{tab.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <Outlet />
      )}
    </div>
  )
}
